import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const tickCalEventChecklistItemInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
    itemId: requiredUuidString('Checklist item is required.', 'Invalid checklist item ID.'),
    checked: z.boolean(),
});
//# sourceMappingURL=tick-cal-event-checklist-item-input.js.map